var app = angular.module('leonardo');

var PermanenceFilter = function (TemplateService) {
  return function (template) {
    if (template && template.permanence !== null && template.permanence !== undefined && template.permanence !== '') {
      switch (template.recurrence_type.toString()) {
        case TemplateService.RECURRENCE_DAILY:
          return `${template.permanence} ${template.permanence > 1 ? 'days' : 'day'}`;
        case TemplateService.RECURRENCE_FIXED_DATE:
          return `${template.permanence} ${template.permanence > 1 ? 'days' : 'day'}`;
        case TemplateService.RECURRENCE_WEEKLY:
          return `${template.permanence} ${template.permanence > 1 ? 'days' : 'day'}`;
        case TemplateService.RECURRENCE_MONTHLY:
          return `${template.permanence} ${template.permanence > 1 ? 'weeks' : 'week'}`;
        case TemplateService.RECURRENCE_YEARLY:
          return `${template.permanence} ${template.permanence > 1 ? 'months' : 'month'}`;
      }
    }
    return '-';
  };
};

app.filter('permanence', ['TemplateService', PermanenceFilter]);
